import React from 'react';
import '../../styles/GridBoxes.css';
import tour from '../../assets/tour.png';
import { Link } from 'react-router-dom';

export default function SecondaryBox3 (props) {

  return (
    <div className='box'>
        <h1>{props.SecondaryBoxTitle3}</h1>
        
        <Link to="/tour">
        <img className="no-box" 
        style={{ boxShadow: 'none' }}  
        src={tour} 
        alt="" />
        </Link>
    </div>
  );
};